import { ITranslationKeys } from '../ITranslationKeys'

export const es: ITranslationKeys = {
    alert: {
        heading: '¡Ups! Parece que hay un problema.',
        generic:
            'Por favor, actualiza la página o contacta con soporte si el problema persiste. ¡Gracias por tu paciencia!',
        expiredSession: (count: number = 0) =>
            `Parece que tu sesión ha expirado. Redirigiendo en ${count} segundos...`,
        retry: 'Reintentar',
        noData: {
            heading: 'No hay datos disponibles',
        },
    },
    banner: {
        opensNewTab: 'Se abre en una pestaña nueva',
    },
    common: {
        goBackAriaLabel: 'Volver a la pantalla anterior',
        cancel: 'Cancelar',
        continue: 'Continuar',
    },
    dateFormat: {
        monthAbbreviations: {
            Jan: 'ene',
            Feb: 'feb',
            Mar: 'mar',
            Apr: 'abr',
            May: 'may',
            Jun: 'jun',
            Jul: 'jul',
            Aug: 'ago',
            Sep: 'sep',
            Oct: 'oct',
            Nov: 'nov',
            Dec: 'dic',
        },
        weekFormat: 'Semana {{weekNumber}} de {{month}}',
        dayFormat: '{{day}} de {{month}}',
    },
    assetsProtection: {
        title: 'Protección de activos',
        filters: {
            viewInDollars: 'Ver en $',
            viewInPercent: 'Ver en %',
        },
        yearToDate: 'Año a la fecha',
        tabs: {
            payroll: 'Nóminas',
            theft: 'Robo',
            secure: 'Seguridad',
        },
        secure: {
            title: 'Seguridad',
            security: 'Seguridad',
            location: 'Ubicación',
            crimesAgainstProperty: 'Delitos contra la propiedad',
            crimesAgainstPeople: 'Delitos contra las personas',
            disorderlyConducts: 'Alteración del orden público',
            securityResolution: '% de resolución de seguridad',
            'disorderly conducts': 'Alteración del orden público',
            'crimes against people': 'Delitos contra las personas',
            'crimes against property': 'Delitos contra la propiedad',
            ty: 'Este año',
            'b/(p) to ly': 'B/(P) frente al año pasado',
        },
        payroll: {
            actual: 'Real',
            plan: 'Plan',
            published: 'Publicado',
            'b/(p) to plan': 'B/(P) flex respecto al plan',
            'b/(p) to published': 'B/(P) frente a lo publicado',
            payrollBPLYLabel: 'B/P % frente al plan',
            apl: 'APL',
            aps: 'APS',
            tps: 'TPS',
        },
        theft: {
            'merchandise investigations': 'Investigaciones de mercancía',
            'POS/other investigations': 'POS/otras investigaciones',
            'detained apprehensions': 'Capturas con detenciones',
            'external app productivity': 'Productividad de capturas externas',
            'average app $': 'Captura promedio $',
            'NPI rate': 'Tasa de NPI',
            PMR: 'PMR',
            KTR: 'KTR',
            ty: 'Este año',
            'b/(p) to ly': 'B/(P) frente al año pasado',
            'days to close (avg)': 'Días para cerrar (prom.)',
            internal: 'Interno',
            external: 'Externo',
        },
        internal: 'Interno',
        external: 'Externo',
        priorWeek: 'Semana anterior',
        priorMonth: 'Mes anterior',
        headers: {
            internal: {
                loc: 'Ubicación',
                merchCases: 'Casos de mercancía',
                merchCasesBPLY: 'Casos de mercancía B/(P) frente al año pasado',
                posOtherCases: 'POS/Otras investigaciones',
                posOtherCasesBPLY:
                    'POS/otras investigaciones b/p frente al año pasado',
                daysToClose: 'Días para cerrar (prom.)',
            },
            external: {
                loc: 'Ubicación',
                detainedApps: 'Detenciones',
                KTRToAppPercent: '% de KTR a detención',
                externalAppProductivity: 'Productividad de capturas externas',
                averageAppDollars: 'Captura promedio $',
                npiRate: 'Tasa de NPI',
            },
            payrollRGDMonthly: {
                Store: 'Ubicación',
                Region: 'Ubicación',
                Group: 'Ubicación',
                District: 'Ubicación',
                'Actual Hrs': 'Horas reales',
                'Plan Hrs': 'Horas planificadas',
                'Published Hrs': 'Horas publicadas',
                'b/(p) to Plan': 'B/(P) frente al plan',
                'b/(p) % to Plan': 'B/(P) % frente al plan',
                'b/(p) % to Published': 'B/(P) % frente a lo publicado',
            },
        },
    },
    brands: {
        title: 'Marcas',
        search: 'Buscar',
        clearSearch: 'Borrar búsqueda',
        goBackAriaLabel: 'Volver a la pantalla de marcas',
        noData: 'No hay datos disponibles',
        trend: 'Tendencia',
        headings: {
            location: 'Ubicación',
            sales: 'Ventas',
            orgSales: 'Ventas originadas',
            fulSales: 'Ventas de Fulfillment',
            originated: 'Originadas',
            shipFromStore: 'Ship from Store',
            orderPickup: 'Servicio order pickup',
            compPercent: '% Comp',
            itemDescription: 'Descripción del artículo',
            quantity: 'Cant.',
            subclass: 'Subcategoría',
            loyaltyOrigTrans: 'Loyalty Orig. Trans %',
        },
        tabs: {
            top: 'Mejores',
            bottom: 'Peores',
        },
    },
    storeFulfillment: {
        title: 'Ejecución de pedidos de la tienda',
        tabs: {
            pickup: 'Pickup',
            ship: 'Ship',
            inf: 'INF',
            ndd: 'NDD',
            capabilities: 'Capacidades',
        },
        timePeriods: {
            today: 'Hoy',
            yesterday: 'Ayer',
            weekToDate: 'Semana a la fecha',
            lastWeek: 'Última semana',
            monthToDate: 'Del mes a la fecha',
            yearToDate: 'Del año a la fecha',
        },
        headings: {
            location: 'Ubicación',
            pickup: 'Pickup',
            groceryPickup: 'Grocery Pickup',
            driveUp: 'Drive Up',
            driveUpReturns: 'Devoluciones de Drive Up',
            driveUpStarbucks: 'Drive Up Starbucks',
            parkingLotDeliveryPause: 'Pausa de entrega en estacionamiento',
            sfs: 'SFS',
            ndd: 'NDD',
            sdd: 'SDD',
            infPercent: '% de INF',
            infDollars: '$ de INF',
            pickedOnTime: '% de pick a tiempo',
            driveUpWaitTime: '% de tiempo de espera en Drive Up',
            receivedUnits: 'Unidades recibidas',
            openLateUnits: 'Unidades abiertas atrasadas',
            openUnits: 'Unidades abiertas',
            pickedUnitsToday: 'Unidades de las que se hizo pick hoy',
            pickedUnits: 'Unidades con pick completado',
            forecastedToday: 'Previstas para hoy',
            totalPickupInf: '% total de INF de Pickup',
            totalPickupAttempted: 'Total de picks intentados',
            pickupUnitsAttempted: 'Total de unidades de Pickup intentadas',
            groceryUnitsAttempted: 'Unidades de comestibles intentadas',
            totalPickupPickProductivity:
                'Productividad total de pick para Pickup (UPH)',
            compPercent: '% Comp',
            forecastedUnits: 'Unidades previstas',
            openUnitsCarrier:
                'Unidades abiertas a la recolección del transportista',
            openUnitsPack: 'Unidades abiertas para empacar hoy',
            shipByTime: 'Ship by Time',
            sortByTime: 'Sort by Time',
            pick: 'Pick',
            pack: 'Pack',
            total: 'Total',
            teamMember: 'Miembro de equipo',
            attemptedUnits: 'Unidades intentadas',
            picksPerHour: 'Picks por hora',
            unitsPacked: 'Unidades empacadas',
            packsPerHour: 'Packs por hora',
            unitPlan: 'Plan de unidades',
            shipOnTimePercent: '% de ship a tiempo',
            pickProductivity: 'Productividad de pick',
            packProductivity: 'Productividad de pack',

            todaysWork: 'Trabajo de hoy',
            carryoverUnits: 'Unidades trasladadas del día anterior',
            completedUnits: 'Unidades completadas',
            remainingUnitPlan: 'Plan de unidades restantes',
            percentINF: '% de INF (En la meta)',
            priorDayLateUnits: 'Unidades atrasadas del día anterior',
            priorDayCarryoverUnits: 'Unidades trasladadas del día anterior',
            lateUnits: 'Unidades atrasadas',
            containersToSort: 'Contenedores por clasificar',
            sortedOnTime: 'Clasificados a tiempo',
            handoffAccuracy: 'Precisión de entrega',
            carryOverUnits: 'Unidades trasladadas del día anterior',
        },
        titles: {
            unitVolume: 'Volumen de unidades',
            teamMemberProductivity: 'Productividad del miembro del equipo',
            todayAsOf: 'Hoy al',
            carrierPickup: 'Carrier Pickup',
            totalUnitsToPack: 'Total de unidades para empacar hoy',
            remainingAvailable: 'Unidades disponibles',
        },
        shipOnTimeHeadings: {
            location: 'Ubicación',
            originalPackagesDue: 'Paquetes originales pendientes',
            acceptedCarrierIssuePackages:
                'Paquetes aceptados con problema del transportista',
            totalPackagesDue: 'Total de paquetes pendientes',
            shipOnTimePercent: '% de envíos a tiempo',
            packagesNotSortedOnTimePercent:
                '% de paquetes no clasificados a tiempo',
            packagesNotShippedNoCarrierIssuePercent:
                '% de paquetes no enviados sin problema del transportista presentado',
            mnrPackagesPercent: '% de paquetes MNR',
        },
        shipOnTimeNote:
            'El porcentaje de envíos a tiempo puede cambiar durante los próximos cuatro días a medida que se recojan los MNR.',
        toggles: {
            showStores: 'Mostrar tiendas',
            showDistricts: 'Mostrar distritos',
        },
        ndd: {
            routeSort: 'Clasificación en rutas',
            handoff: 'Entrega a conductores',
            byTime: 'Para la hora',
            completed: 'Completadas',
            totalExpected: 'Total esperado',
            percentOnTime: '% a tiempo',
            accuracy: 'Exactitud',
            asOf: 'Al día',
            containersSorted: 'Clasificación en contenedores',
            infPercent: '% de INF',
            sortedOnTime: 'Clasificados a tiempo',
            shippedOnTime: 'Enviados a tiempo',
        },
        inf: {
            store: {
                orderPickupOPU: 'Servicio Order Pickup (OPU)',
                units: 'Unidades',
                dollars: 'Dólares',
                inf: '% de INF',
                sfs: '% de SFS',
                shipFromStoreSFS: 'Ship from Store (SFS)',
                infTime: 'Tiempo de INF',
                infUnits: 'Unidades de INF',
                attemptedUnits: 'Unidades intentadas',
                dpci: 'DPCI',
                item: 'Artículo',
                teamMember: 'Miembro de equipo',
                totalMinutes: 'Total de minutos',
                orderNumber: 'Número de orden',
                asOf: 'Al',
                capabilityStatus: 'Estado de capacidad',
                ON: 'ACTIVO',
                OFF: 'INACTIVO',
                PAUSED: 'PAUSADO',
                lastUpdated: 'Última actualización',
                reason: 'Motivo',
                department: 'Departamento',
            },
            rgdHeadings: {
                pickup: {
                    totalPickupInf: 'Total de INF de Pickup',
                    pickupINFApparel: 'INF de Pickup, apparel/accessories',
                    pickupINFBeauty: 'INF de Pickup, essentials/beauty',
                    pickupINFFoodBeverage: 'INF de Pickup, food/beverage',
                    pickupINFHardlines: 'INF de Pickup, hardlines',
                    pickupINFHome: 'INF de Pickup, home',
                },
                ship: {
                    totalShipINF: 'Total de INF de Ship',
                    shipINFApparel: 'INF de Ship, apparel/accessories',
                    shipINFBeauty: 'INF de Ship, essentials/beauty',
                    shipINFFoodBeverage: 'INF de Ship, food/beverage',
                    shipINFHardlines: 'INF de Ship, hardlines',
                    shipINFHome: 'INF de Ship, home',
                },
                tableHeaders: {
                    units: 'Unidades',
                    dollars: 'Dólares',
                    inf: '% de INF',
                },
            },
        },
        unitsCompletedLabel: (percent: number) =>
            `${percent}% de unidades completadas`,
    },
    loyalty: {
        title: 'Lealtad',
        tabs: {
            overview: 'Información general',
            targetCircle: 'Target Circle',
            targetCircleCard: 'Tarjeta Target Circle',
            targetCircle360: 'Target Circle 360',
        },
        timePeriods: {
            currentWeek: 'Semana a la fecha',
            lastWeek: 'Última semana',
            monthToDay: 'Del mes a la fecha',
            yearToDay: 'Del año a la fecha',
        },
        overview: {
            currentWeek: 'Semana actual',
            lastWeek: 'Última semana',
            targetCircleCard: 'Tarjeta Target Circle',
            percentTranslationsTargetCircle:
                '% de transacciones con Target Circle',
            percentTranslationsTargetCircleCard:
                '% de transacciones con tarjeta Target Circle',
            Sun: 'dom',
            Mon: 'lun',
            Tue: 'mar',
            Wed: 'mié',
            Thu: 'jue',
            Fri: 'vie',
            Sat: 'sáb',
            location: 'Ubicación',
            targetCircle: 'Target Circle',
            targetCircleCardHeading: 'Tarjeta Target Circle',
            total: 'Total',
        },
        targetCircle: {
            signUps: 'Nuevas inscripciones',
            location: 'Ubicación',
            forecast: 'Pronóstico',
            'target circle signups': 'Inscripciones a Target Circle',
            'target circle 360 signups': 'Inscripciones a Target Circle 360',
            targetCircleSignUps: 'Inscripciones a Target Circle',
            percentToForecast: '% al pronóstico',
            total: 'Total',
            '% to forecast': '% al pronóstico',
        },
        circleCard: {
            applications: 'Aplicaciones',
            applicationNumbers: (totalApps: string, forecastApps: string) =>
                `${totalApps} de ${forecastApps}`,
            summary: 'Resumen',
            location: 'Ubicación',
            total: 'Total',
            forecast: 'Pronóstico',
            '% to forecast': '% al pronóstico',
        },
    },
    indexRedirectMessage: 'Redirecting to login',
    layout: {
        appTitle: 'myPerformance Mobile',
        greenfieldLinkTitle: 'Greenfield',
        logOutCTA: 'Cerrar sesión',
        navMenuAriaLabel: 'Abrir menú',
        navMenuCloseAriaLabel: 'Cerrar menú',
        searchAriaLabel: 'Buscar ubicación',
    },
    locationSearch: {
        header: 'Seleccionar ubicación',
        searchLabel: 'Buscar por región, grupo, distrito o tienda',
        matchNotFound:
            'Ninguna ubicación coincide con su búsqueda. Se muestran las ubicaciones cercanas.',
        nearbyLocationsHeader: 'Ubicaciones cercanas',
        clearSearchAriaLabel: 'Borrar la consulta de búsqueda de ubicación',
    },
    payroll: {
        title: 'Nóminas',
        planHrs: 'Horas del plan',
        actRemSchedHrs: 'Horas programadas reales+restantes',
        weekNo: 'Semana #',
        payrollRegion: 'Región',
        tabs: {
            location: 'Ubicación',
            workgroup: 'Grupo de trabajo',
            overtime: 'Horas extra',
            monthly: 'Mensual',
        },
        location: {
            title: 'Nómina por ubicación',
            loc: 'Ubicación',
            payrollByLocation: 'Nómina por ubicación',
            payrollByWeek: 'Nómina por semana',
            projFlexHours: 'Flex de la carga de trabajo',
            trailerFlexHours: 'Horas flexibles de tráiler',
            adjustments: 'Ajustes',
            asOf: 'Al día',
            location: 'Ubicación',
            variance: 'Desviación',
            thisMonth: 'Este mes',
            lastMonth: 'Mes pasado',
            nextMonth: 'Próximo mes',
            otherAdjustments: 'Otros ajustes',
            projFlexHrs: 'Horas flex proyectadas',
            trailerFlex: 'Flex de tráiler',
            nextMonthUnavailable:
                'Los datos del próximo mes aún no están disponibles.',
        },
        workgroup: {
            title: 'Horas planificadas por grupo de trabajo',
            workGroup: 'Grupo de trabajo',
        },
        overtime: {
            title: '% de horas extra semanales del total de horas - tendencia',
            actualPct: '% real',
            lyAdMappedPct: '% del año pasado (ajustado al aviso)',
            bpTtoLyAdMappedPct:
                'b/(p) frente al año pasado (ajustado al aviso)',
        },
    },
    itemSearch: {
        title: 'Detalles del artículo',
        searchLabel: 'Buscar artículo',
        searchButtonText: 'Buscar',
        searchInputPlaceholder: 'Buscar o escanear',
        searchInputPlaceholderZebra: 'Toque Aquí para Buscar o Escanear',
        scanButtonAriaLabel: 'Toque para usar el escáner',
        dpciLabel: 'DPCI:',
        dpciAriaLabel: 'DPCI',
        placementCapacityDescription: ' cabe',
        onHandRow: 'Cantidad disponible',
        onWithdrawalRow: 'Cantidad en camino',
        lastAuditedRow: 'Fecha de la última auditoría',
        lastReceivedRow: 'Fecha de la última recepción',
        lastSoldRow: 'Fecha de la última venta',
        totalSalesCardTitle: 'Resultados totales de ventas',
        averageSalesCardTitle: 'Resultados promedio de ventas',
        location: 'Ubicación',
        company: 'Compañía',
        district: 'Distrito',
        store: 'Esta tienda',
        unitsSold: 'Unidades vendidas',
        sales: 'Ventas $',
        itemNotFound: 'Artículo no encontrado',
        stopScanning: 'Detener escaneo',
        quantityCheck: (floorQty: number = 0, backQty: number = 0) =>
            `${floorQty} on floor, ${backQty} in back`,
        tabs: {
            actual: 'Real',
            forecast: 'Pronóstico',
        },
    },
    safety: {
        title: 'Seguridad',
        lagging: {
            title: 'Seguridad rezagada',
            Location: 'Ubicación',
            'Guest Incident Rate': 'Tasa de incidentes de clientes',
            'TM Inj 8wk Rate':
                'Tasa de lesiones de miembros de equipo en 8 semanas',
            'TM Inj YTD Rate':
                'Tasa de lesiones de miembros de equipo en el año a la fecha',
            Company: 'Target',
        },
        total: {
            title: 'Seguridad total',
            Location: 'Ubicación',
            'All TM Reported YTD ':
                'De todos los TM reportadas en lo que va del año',
            'All Guest Reported YTD':
                'De todos los clientes reportadas en lo que va del año',
            'Hazards/Near Misses':
                'Peligros/Situaciones que casi producen un incidente',
            Company: 'Target',
        },
        leading: {
            title: 'Indicadores adelantados',
            Location: 'Ubicación',
            'Safety Meetings': 'Reuniones de seguridad',
            Observations: 'Observaciones',
            'Action Plans': 'Planes de acción',
            Investigations: 'Investigaciones',
            'Invest Action Plans': 'Planes de acción de investigación',
            Company: 'Target',
        },
        tabs: {
            lagging: 'Rezagados',
            total: 'Total',
            leading: 'Adelantados',
        },
        nonStoreLabel:
            'Los datos se actualizan el miércoles y son válidos hasta el sábado',
        store: {
            'Lagging Indicators': 'Indicadores rezagados',
            'Total Incidents': 'Incidentes de seguridad del equipo',
            'Leading Indicators': 'Indicadores adelantados',
        },
    },
    sales: {
        title: 'Ventas',
        noPermission:
            'Parece que no tienes permiso para ver los datos de ventas de esta ubicación. ' +
            'Esta información está restringida a ciertos roles.',
        tabs: {
            overview: 'General',
            details: 'Detalles',
            location: 'Ubicación',
        },
        timePeriods: {
            today: 'Hoy',
            yesterday: 'Ayer',
            weekToDate: 'Semana a la fecha',
            lastWeek: 'Última semana',
            monthToDate: 'Del mes a la fecha',
            lastMonth: 'Último mes',
            yearToDate: 'Del año a la fecha',
        },
        filters: {
            compPercent: '% Comp',
            viewInDollars: 'Ver en $',
            viewInPercent: 'Ver en %',
        },
        overview: {
            hourlySales: 'Ventas por hora',
            originated: 'Originadas',
            lineBusting: 'De cobro móvil',
            fulfilled: 'De Fulfillment',
            shipFromStore: 'Ship from Store',
            driveUp: 'Drive Up',
            orderPickup: 'Servicio order pickup',
            shipt: 'Shipt',
            otherSales: 'Otras ventas',
            saveTheSale: 'Salvar la venta',
            goal: 'Meta',
            lastYear: 'Ventas del año pasado',
            compPercent: '% Comp',
            originatedCompPercent: '% comparativo de originadas',
            fulfilledCompPercent: '% comparativo de Fulfillment',
            twoYearCagr: 'CAGR de 2 años',
            basketSize: 'Canasta',
            transactions: 'Transacciones',
            total: 'Total',
            ly: 'Año pasado',
            bpToLy: 'B/P frente al año pasado',
            bpToLyPercent: 'B/P frente al año pasado %',
            goalPercentage: 'with a goal percentage of',
            of: 'de',
            basketSizeDollar: 'Canasta $',
            basketSizeUnits: 'Unidades de la canasta',
        },
        details: {
            workarea: {
                title: 'Área de trabajo',
                tabs: {
                    sales: 'Ventas',
                    salesMix: 'Combinación de ventas',
                    merch: 'Mercancía',
                    'orig. sales': 'Ventas originales',
                    'ful. sales': 'Ventas de Fulfillment',
                    timePeriods: {
                        today: 'Hoy',
                        yesterday: 'Ayer',
                        weekToDate: 'Semana a la fecha',
                        lastWeek: 'Última semana',
                        monthToDay: 'Del mes a la fecha',
                        yearToDay: 'Del año a la fecha',
                    },
                },
            },
            merch: {
                title: 'Ventas por mercancía',
                tabs: {
                    sales: 'Ventas',
                    salesMix: 'Combinación de ventas',
                    merch: 'Mercancía',
                    'orig. sales': 'Ventas originales',
                    'ful. sales': 'Ventas de Fulfillment',
                    timePeriods: {
                        today: 'Hoy',
                        yesterday: 'Ayer',
                        weekToDate: 'Semana a la fecha',
                        lastWeek: 'Última semana',
                        monthToDay: 'Del mes a la fecha',
                        yearToDay: 'Del año a la fecha',
                    },
                },
            },
        },
        location: {
            title: 'Ventas por ubicación',
            tabs: {
                region: 'Región',
                Region: 'Región',
                group: 'Grupo',
                district: 'Distrito',
                store: 'Tienda',
                sales: 'Ventas',
                goal: 'Meta',
                forecast: 'Pronóstico',
                'variance %': '% de desviación',
                variance: 'Desviación',
                compPercent: '% Comp',
                'comp %': '% Comp',
                'ly ad mapped': 'Del año pasado (ajustado al aviso)',
                '2 yr cagr %': '% crecimiento anual compuesto (2 años)',
            },
        },
        hourly: {
            hour: 'Hora',
            today: 'Hoy',
            variance: 'Desviación',
            lyAdMapped: 'Del año pasado (ajustado al aviso)',
            Transaction_count: 'Cantidad de transacciones',
            'Basket Size $': 'Tamaño de la canasta ($)',
            'Basket Size U': 'Tamaño de la canasta (unid.)',
            'Basket $ b/(P) % LY': 'Canasta $ b/(P) % frente al año pasado',
            'Basket Units b/(P) % LY':
                'Canasta unid. b/(P) % frente al año pasado',
            'Transaction Count b/(P) % LY':
                'Cantidad de transacciones b/(P) % frente al año pasado',
        },
    },
    shortage: {
        title: 'Descuadre de inventario',
        totalShortage: 'Descuadre total',
        'last inventory date': 'Última fecha de inventario',
        'next scheduled inventory date':
            'Fecha del siguiente inventario programado',
        thisYear: {
            title: 'Este año',
        },
        merch: {
            title: 'Descuadre de inventario',
        },
        top10: {
            title: '10 descuadres principales',
        },
        filters: {
            viewInDollars: 'Ver en $',
            viewInPercent: 'Ver en %',
        },
        table: {
            merch: 'Mercancía',
            dept: 'Departamento',
            class: 'Clase',
            'focus areas': 'Áreas de enfoque',
            'shortage $': 'Descuadre $',
            'b/p ly $': 'B/P frente al año pasado $',
            'b(p) ly $': 'B(P) frente al año pasado $',
            'shortage %': 'Descuadre %',
            'b/p ly %': 'B/P frente al año pasado %',
            'b(p) ly %': 'B(P) frente al año pasado %',
            location: 'Ubicación',
            'gm $': 'GM $',
            'gm % ': 'GM % ',
            'perishable $': 'Perecederos $',
            'perishable % ': 'Perecederos % ',
            region: 'Región',
            group: 'Grupo',
            district: 'Distrito',
        },
    },
    storeFacts: {
        title: 'Datos sobre la tienda',
        quickFacts: 'Datos generales',
        lastYearSales: 'Ventas del año pasado',
        originatedSales: 'Ventas originadas',
        fulfilledSales: 'Ventas de Fulfillment',
        totalSales: 'Ventas totales',
        hours: 'Horas',
        keyDates: 'Fechas clave',
        opened: 'Abierto',
        lastRemodel: 'Última remodelación',
        notAvailable: 'No hay datos',
        packStation: 'Estación de empaque',
        leadership: 'Liderazgo',
        store: 'Tienda',
        role: 'Función',
        name: 'Nombre',
        since: 'Desde',
        capabilities: 'Capacidades',
        to: 'A',
        field: 'Campo',
        inboundNodes: 'Centros de recepción',
        outboundNodes: 'Centros de despacho',
    },
    myTargetPerformance: {
        title: 'MyTarget Performance',
        noMetricsAvailable: 'No hay métricas de {{metricType}} disponibles',
        tabs: {
            guest: 'Cliente',
            financial: 'Resultados',
            team: 'Equipo',
        },
        historicalDetails: 'Detalles históricos',
        goal: 'Meta',
        seeDetails: 'Ver detalles',
        pctGreenStores: '% tiendas verdes',
        location: 'Ubicación',
        company: 'Target',
        sections: {
            financial: 'Resultados financieros',
            guestCompliance: 'Cumplimiento de invitados',
            guestEngagement: 'Participación de invitados',
            guestImpact: 'Impacto en los invitados',
            guestReadiness: 'Preparación para los invitados',
            guestSatisfaction: 'Satisfacción de los invitados',
            team: 'Equipo',
        },
        metricTypes: {
            outcomes: 'Resultados',
            levers: 'Palancas',
        },
        timePeriods: {
            priorDay: 'Ayer',
            priorWeek: 'LW',
            last4Weeks: 'L4W',
            priorMonth: 'LM',
            priorQuarter: 'LQ',
            priorYear: 'LY',
            weekToDay: 'WTD',
            monthToDay: 'MTD',
            monthToWeek: 'MTW',
            quarterToWeek: 'QTW',
            yearToDay: 'YTD',
            yearToWeek: 'YTW',
        },
        timePeriodLabels: {
            priorDay: 'Ayer',
            priorWeek: 'Semana pasada',
            last4Weeks: 'Últimas 4 semanas',
            priorMonth: 'Mes pasado',
            priorQuarter: 'Trimestre pasado',
            priorYear: 'Año pasado',
            weekToDay: 'Semana a la fecha',
            monthToDay: 'Mes a la fecha',
            monthToWeek: 'Mes a la semana',
            quarterToWeek: 'Trimestre a la semana',
            yearToDay: 'Año a la fecha',
            yearToWeek: 'Año a la semana',
        },
    },
    notes: {
        notes: 'Notas',
        sales: 'Ventas',
        payroll: 'Nóminas',
        of: 'de',
        hours: 'Horas',
        flexPlan: 'Flex plan',
        weather: 'Clima',
        keyStatistics: 'Estadísticas importantes',
        'at goal': 'En la meta',
        'below goal': 'Por debajo de la meta',
        pickOnTime: 'Pick a tiempo',
        sfsInf: 'SFS INF',
        opuInf: 'OPU INF',
        high: 'Alto',
        low: 'Bajo',
        comp: 'Comp',
        errorText: 'Ingresa una fecha válida',
        datePickerLabel: 'Seleccionar fecha',
        permissions: {
            noAccess:
                'No tienes acceso para ver notas de esta ubicación. Si crees que es un error, consulta con tu líder.',
            noNotesPermissions:
                'No tienes permisos para ver notas. Si crees que es un error, consulta con tu líder.',
            userLocationNotAvailable:
                'No pudimos confirmar tu acceso a la ubicación. No se pueden mostrar notas.',
            accessDeniedLocation:
                'Puedes ver notas de la Tienda {{userStoreId}}, pero no de la Tienda {{currentStoreId}}. ' +
                'Si crees que esto es un error, consulta con tu líder.',
            writeAccessLimited:
                'Solo puedes escribir notas para tu tienda asignada (Tienda {{userStoreId}}).  ' +
                'Si crees que esto es un error, consulta con tu líder.',
        },
        items: {
            addButton: 'Agregar',
            editButton: 'Editar',
            deleteButton: 'Eliminar',
            todo: {
                title: 'Pendientes',
                label: 'Agregar siguiente pendiente',
                key: 'to_do',
            },
            attendance: {
                title: 'Asistencia',
                label: 'Agregar siguiente asistencia',
                key: 'attendance',
            },
            notes: {
                title: 'Notas',
                label: 'Agregar nota',
                key: 'notes',
            },
            updateButton: 'Actualizar',
            deleteConfirmTitle: '¿Estás seguro de que quieres eliminar esto?',
            cancelButton: 'Cancelar',
            confirmButton: 'Eliminar',
        },
        legacy: {
            title: 'Notas heredadas',
            subtitle: 'Solo lectura',
        },
    },
    operationalMetrics: {
        title: 'Operaciones',
        historicalDetails: 'Detalles históricos',
        seeChartView: 'Ver la vista de tabla',
        recall: {
            tabs: {
                operations: 'Operaciones',
                recall: 'Recall',
                incompleteRecalls: 'Recalls incompletos',
            },
            search: {
                label: 'Buscar por número de IR',
                placeholder: 'Buscar número de IR',
                noResults: 'Ningún recall coincide con tu búsqueda.',
                clearAriaLabel: 'Borrar búsqueda de recalls',
            },
            headings: {
                location: 'Ubicación',
                store: 'Tienda',
                district: 'Distrito',
                group: 'Grupo',
                region: 'Región',
                irNumber: 'Número de IR',
            },
        },
        timePeriods: {
            priorDay: 'Ayer',
            weekToDay: 'Semana a la fecha',
            priorWeek: 'Semana anterior',
            monthToDay: 'Del mes a la fecha',
            priorMonth: 'Mes anterior',
            yearToDay: 'Del año a la fecha',
        },
        headers: {
            needsAttention: 'Necesita atención',
            atGoal: 'En la meta',
            belowGoal: 'Por debajo de la meta',
        },
        detailsColumns: {
            location: 'Ubicación',
            'area of store': 'Área de la tienda',
            'INF units': 'Unidades INF',
            'total attempted units': 'Total de unidades intentadas',
            'INF $': '$ INF',
            'INF %': '% INF',
            'Total Picks Attempted': 'Total de picks intentados',
            'Total Units INF %': '% INF del total de unidades',
            'Total Units INF': 'Total de unidades INF',
            'Total INF $': '$ INF total',
            '% of Stores Meeting Goal': '% de tiendas que cumplen la meta',
            'BAI %': '% BAI',
        },
        operationsCards: {
            'Pick On Time %': '% de pick a tiempo',
            'Total Picks Attempted': 'Total de picks intentados',
            'Total Units Picked On Time':
                'Total de unidades de las que se hizo pick a tiempo',
            'SFS INF %': '% de INF de SFS',
            'Pick Up INF %': '% de INF de Pick Up',
            'Ship On-Time %': '% de envíos a tiempo',
            'Total Units Due To Ship Today':
                'Total de unidades que se deben enviar hoy',
            'Return to Stock': 'Devolver al inventario (RTS)',
            'Total RTS Tasks': 'Total de tareas de RTS',
            'Drive Up Wait Time': 'Tiempo de espera en Drive Up',
            'Delivery Trips': 'Viajes para entregas',
            'Total Priority Fill %': '% total de priority fill',
            'OSA Store Addressable Lost Sales':
                'OSA ventas perdidas atribuibles a la tienda',
            'Store Addressable Lost Sales %':
                '% de ventas perdidas atribuibles a la tienda',
            'Never Outs: OSA Store Addressable Lost Sales':
                'Never Outs: OSA ventas perdidas atribuibles a la tienda',
            'Event Activations': 'Activaciones de eventos',
            'Total Events Activated': 'Total de eventos activados',
            'Ticketed/Salvage Unit Accuracy %':
                '% de precisión de las unidades de salvage o con ticket',
            'Total Actual Units': 'Total de unidades reales',
            'Guest Price Chal %':
                'Reclamos de clientes por discrepancia de precios',
            '# Tasks': 'Núm. de tareas',
            '# of Tasks': 'Núm. de tareas',
            'RFID Compliance %': '% de cumplimiento de RFID',
            'Scan %': '% de escaneo',
            'Backroom Audit Completion %':
                '% de finalización de la auditoría de la bodega',
            'Backroom Audit Tasks': 'Tareas de auditoría de la bodega',
            'Sales Floor Audit Completion %':
                '% de finalización de la auditoría del piso de ventas',
            'Suspect Task': 'Tarea sospechosa',
            'Belted Lane Utilization %':
                '% de uso de cajas registradoras con banda',
            'Self Checkout Utilization %': '% de uso de cajas de autopago',
            'Check Date Completion %':
                '% de finalización de verificación de fechas',
            'Check Date Completion % (FOOD & BEVERAGE)':
                '% de finalización de verificación de fechas (FOOD & BEVERAGE)',
            'Check Date Completion % (ESSENTIALS & BEAUTY)':
                '% de finalización de verificación de fechas (ESSENTIALS & BEAUTY)',
            '# DPCI Pulled': '# de DPCI retirados',
            'Drive Up TM Interaction': 'Interacciones de TM en Drive Up',
            'Drive Up TM Interaction LY':
                'Interacciones de TM en Drive Up del año pasado',
            'Set On-Time %': '% de sets a tiempo',
            '# of POGs Due': '# de POGs pendientes',
            'ESIM Completion %': '% de cumplimiento de ESIM',
            'Completed Log': 'registros completados',
            'Wait Time at Checkout': 'tiempo de espera en cajas',
            'TM Interaction at Checkout': 'interacciones de TM en cajas',
            'Order Pickup TM Interaction':
                'Interacciones de TM en Order Pickup',
            'Order Pickup TM Interaction LY':
                'Interacciones de TM en Order Pickup del año pasado',
            'Salesfloor TM Interaction':
                'Interacciones de TM en el piso de ventas',
            Cleanliness: 'Limpieza',
            'Backroom Accuracy Indicator':
                'Indicador de exactitud del backroom',
            '% of Stores Meeting Goal': '% de tiendas que cumplen la meta',
            'Pick Up Quality Defect %': '% de defectos de calidad en Pickup',
            'Total Defect Units': 'Total de unidades defectuosas',
            'Salvage Fill Completion %':
                '% de cumplimiento de reposición de salvage',
            'Tasks Completed': 'Tareas completadas',
            'Price Change %': '% de cambios de precio',
            'Task Actuals': 'Tareas reales',
            'Price Audit %': '% de auditorías de precio',
            'Task Expected': 'Tareas previstas',
            'SFS Total Defect Rate %': '% total de defectos de SFS',
        },
    },
    trailer: {
        title: 'Tráiler',
        tabs: {
            summary: 'Resumen',
            schedule: 'Programación',
        },
        summary: {
            unacknowledgedDcTitle: 'Sin acuse de recibo en DC',
            unacknowledgedStoreTitle: 'Sin acuse de recibo en la tienda',
            unacknowledgedTransitTitle: 'Sin acuse de recibo en tránsito',
            unacknowledgedNoTrackingTitle:
                'Sin acuse de recibo (sin información de rastreo)',
            acknowledgedTitle: 'Con acuse de recibo',
        },
        schedule: {
            title: 'Programación de tráiler',
            timePeriods: {
                currentWeek: 'Semana actual',
                lastWeek: 'Semana pasada',
                nextWeek: 'Próxima semana',
                threeWeeksOut: 'En tres semanas',
                fourWeeksOut: 'En cuatro semanas',
            },
            headers: {
                unloadDateTime: 'Fecha/hora de descarga',
                sequence: 'Secuencia',
                type: 'Tipo',
                sweep: 'Devolución al DC',
            },
        },
        toggles: {
            showRDC: 'Ver RDC',
            showFDC: 'Ver FDC',
        },
        rgd: {
            location: 'Ubicación',
            unacknowledged: 'Sin acuse de recibo',
            red: 'En rojo (> 36 hrs)',
            recentlyAcknowledged: 'Con acuse de recibo reciente',
            today: 'Hoy',
        },
        details: {
            zeroHours: '0 hrs',
            billOfLading: 'Carta de porte',
            unknownMiles: 'Millas desconocidas',
            miles: 'Millas',
            lastApplication: 'Última aplicación',
            table: {
                type: 'Tipo',
                acknowledged: 'Con acuse de recibo',
                closed: 'Cerrado',
                trailerNumber: 'Tráiler #',
                cartons: 'Cajas',
                leadTime: 'Tiempo de entrega',
                laborHours: 'Horas de trabajo',
                stockingTime: 'Tiempo de reposición',
                secondarySortingTime: 'Tiempo de clasificación secundaria',
                customBlock: 'Bloque asignado',
                loadZone: 'Zona de carga',
                caseCartons: 'Cajas por procesar',
                repackCartons: 'Cajas por reempaquetar',
                sortingTime: 'Tiempo de clasificación',
                total: 'Total',
                bulk: 'A granel',
                description: 'Descripción',
                eaches: 'Unidades',
                dpci: 'DPCI',
            },
            workArea: {
                workArea: 'Área de trabajo',
                caseCartons: 'Cajas por procesar',
                caseUnit: 'Unidad de caja',
                repackCartons: 'Cajas por reempaquetar',
                repackUnits: 'Unidades por reempaquetar',
                total: 'Total',
            },
        },
        trailerNotFound: 'No se encontró el tráiler',
    },
    settings: {
        title: 'Configuración',
        info: 'Información',
        you: 'Tú',
        location: 'Ubicación',
        version: 'Versión',
        help: 'Ayuda',
        feedback: 'Opiniones',
        language: 'Idioma',
        languages: {
            en: 'Inglés',
            es: 'Español',
            EN: 'EN',
            ES: 'ES',
        },
        landingPage: 'Página de inicio',
        landingPageDescription:
            'Elige tu página de inicio preferida para la aplicación. Esto se puede actualizar en ' +
            'cualquier momento en la configuración.',
        map: 'Mapa',
        preferredMap: 'Mapa preferido',
        mapMessage: `Elija cómo abrir los mapas. Guardaremos su elección para más adelante,
         pero puede actualizarla en cualquier momento en Configuración.`,

        maps: {
            google: 'Google',
            apple: 'Apple',
        },
        creatingPreferences: 'Creando las preferencias del usuario',
        updatingPreferences: 'Actualizando las preferencias del usuario',
        looksLikeSomethingWentWrong:
            'Parece que algo falló al actualizar las preferencias del usuario',
        loading: 'Cargando',
    },
    transientError: {
        title: 'No pudimos obtener tus permisos en este momento',
        message:
            'No pudimos cargar tus datos de acceso en este momento. ' +
            'Es probable que sea un problema temporal. Inténtalo de nuevo en unos minutos.',
        retryButton: 'Intentar de nuevo',
    },
    unauthorized: {
        title: 'Acceso no autorizado',
        message:
            'MPM está disponible en dispositivos personales para líderes exentos (ETLs y niveles superiores). ' +
            'Los nuevos usuarios deben solicitar acceso en myAccess; busca ' +
            '"myPerformance mobile 2 (MPM2) - Power User - Prod: APP-MPM2-Poweruser".',
        forbiddenMessage: 'No está autorizado para ver este contenido.',
        notFoundTitle: 'No se pudo abrir MPM',
        notFoundMessage:
            'No pudimos cargar la información necesaria para abrir MPM. Inténtalo de nuevo más tarde.',
        noUserDetailsData:
            'No hay información disponible sobre los permisos del usuario',
    },
    generalErrors: {
        loadFailedRetry:
            'No se pudieron cargar los datos. Pulse para reintentar.',
    },
    contact: {
        mainPhone: 'Teléfono principal',
        fax: 'Fax',
    },
    location: {
        region: 'Región',
        group: 'Grupo',
        district: 'Distrito',
        RDC: 'RDC',
        county: 'County',
    },
    timePeriods: {
        today: 'Hoy',
        yesterday: 'Ayer',
        weekToDate: 'Semana a la fecha',
        lastWeek: 'Última semana',
        monthToDate: 'Del mes a la fecha',
        lastMonth: 'Último mes',
        yearToDate: 'Del año a la fecha',
    },
    filters: {
        compPercent: '% Comp',
        viewInPercent: 'Ver en %',
        viewInDollars: 'Ver en $',
        viewItem: 'Ver artículo',
        viewSubclass: 'Ver subcategoría',
    },
    feedback: {
        thankYou: 'Gracias',
        thankYouForSubmitting: 'Gracias por enviar sus comentarios',
        error: 'Error',
        errorSubmitting: 'Error al enviar los comentarios',
        sendAMessage: 'Envíenos un mensaje',
        message: 'Mensaje',
        hereToHelp:
            'Comparte tus comentarios sobre MPM — ¡los usamos para seguir mejorando!',
        submitFeedback: 'Enviar comentarios',
        shareFeedback: 'Compartir comentarios',
        footerAriaLabel: 'Abrir el formulario para compartir comentarios',
    },
    'weekly hours': 'Horas semanales',
    'prior month': 'Mes anterior',
    'Actual Hrs': 'Hrs reales',
    'Plan Hrs': 'Hrs planificadas',
    'Published Hrs': 'Hrs publicadas',
    'b/(p) to Plan': 'B/(P) respecto al plan',
    'b/(p) % to Plan': 'B/(P) % respecto al plan',
    'b/(p) % to Published': 'B/(P) % respecto a lo publicado',
    'Eastern Standard Time': 'Hora del este',
    'Central Standard Time': 'Hora del centro',
    'Mountain Standard Time': 'Hora de la montaña',
    'Pacific Standard Time': 'Hora del Pacífico',
    EST: 'Hora del este',
    CST: 'Hora del centro',
    MST: 'Hora de la montaña',
    PST: 'Hora del Pacífico',
    'pack station': 'Estación de empaque',
    'Adult Beverage Pickup': 'Servicio Pickup de bebidas para adultos',
    'Wine & Beer Available': 'Vino y cerveza disponibles',
    'Beer Available': 'Cerveza disponible',
    'Drive Up': 'Servicio Drive Up',
    'Starbucks Drive Up': 'Servicio Drive Up de Starbucks',
    'Vandal Resistant Glass': 'Vidrio resistente al vandalismo',
    'Fresh Order Pick Up': 'Servicio Order Pick Up de productos frescos',
    'Self Checkout': 'Cajas de autopago',
    'Accepts WIC': 'Acepta WIC',
    'Protects brands advocates in court safer shopping':
        'Protege las marcas, aboga en tribunales, crea un ambiente de compras más seguro',
    'Shipt Delivery': 'Entrega de Shipt',
    'Consumer Cellular Cell Phone Activations':
        'Activaciones de teléfonos celulares de Consumer Cellular',
    'Fresh Grocery': 'Comestibles frescos',
    'AT&T Cell Phone Activations':
        'Activaciones de teléfonos celulares de AT&T',
    'Off duty police or 3rd party security':
        'Oficiales de policía fuera de servicio o guardias de seguridad de servicios externos',
    'Prepaid Cell Phone Activations':
        'Activaciones de teléfonos celulares prepagados',
    'Store Pickup': 'Entrega de pedidos en la tienda',
    'Mobile Operations': 'Operaciones móviles',
    'Drive Up Returns': 'Devoluciones de Drive Up',
    'Prior Day': 'Ayer',
    'Week to Day': 'Semana a la fecha',
    'Prior Week': 'Última semana',
    'Month to Day': 'Del mes a la fecha',
    'Year to Day': 'Del año a la fecha',
    'Go back to the operations screen': 'Volver a la pantalla de operaciones',
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    ytd: 'Del año a la fecha',
    Closed: 'Cerrado',
    Pfresh: 'PFresh',
    'General Merch': 'General Merch',
    'Starbucks Cafe': 'Starbucks Café',
    'CVS pharmacy': 'CVS Pharmacy',
    'Snack Bar - Pizza': 'Snack Bar - Pizza',
    insights: {
        title: 'Resumen de desempeño',
        tabs: {
            yesterday: 'Ayer',
            weekly: 'Semanal',
        },
        details: {
            title: 'Detalle clave',
            yesterday: 'Ayer',
            week: 'Semana del',
            whatChanged: 'Qué cambió',
            whyItMatters: 'Por qué importa',
            whereItsHappening: 'Dónde está ocurriendo',
            recommendedNextMove: 'Próximo paso recomendado',
            tableArea: 'Área',
            tableValue: 'Valor',
            tableCompStore: 'Comp',
            tableCompDistrict: 'Comp comparado con el distrito',
            tableStatus: 'Estado',
            statusStrong: 'Fuerte',
            statusWeak: 'Débil',
        },
        sectionNoData: 'No hay datos disponibles para esta sección.',
        locationNotEnrolled:
            'Los resúmenes no están disponibles para esta ubicación',
        yesterdayAtAGlance: 'Resumen de ayer',
        viewInsightDetails: 'Ver detalle clave',
        topTrendsFromLastWeek: 'Tendencias principales de la semana pasada',
        storePerformance: {
            title: 'Desempeño de la tienda',
            pyramid: 'Pirámide',
            department: 'Departamento',
        },
        category: {
            performance: 'Desempeño',
            digital: 'Digital',
            district: 'Distrito',
        },
        checkBackLater:
            'Vuelve a consultar más tarde para ver los detalles clave',
        errorHeading: 'No se pueden cargar los insights',
        storeInsightsError: {
            heading: 'Los insights solo están disponibles para tu tienda',
            message:
                'Estás viendo una tienda diferente. Para ver los insights, vuelve a tu tienda asignada.',
            button: 'Cambiar a mi tienda',
        },
        summaryDetails: 'Detalles del resumen',
        summaryForWeek: `Resumen de desempeño de la semana del`,
        summaryForYesterday: `Resumen de desempeño de ayer,`,
        noDataTitleYesterday: `El resumen de ayer aún no está disponible`,
        noDataTitleWeekly: `El resumen de esta semana aún no está disponible`,
        categoryPerformance: {
            heading: 'Desempeño por categoría',
            strongVsDistrict: 'Fuerte frente al distrito',
            weakVsDistrict: 'Débil frente al distrito',
        },
        storeDistrictSnapshot: {
            header: 'Resumen de la tienda frente al distrito',
            metric: 'Métrica',
            district: 'Distrito',
            takeaway: 'Conclusión',
        },
        funFacts: {
            header: 'Datos curiosos',
        },
        audioPlayer: {
            listenToBriefing: 'Escuchar el informe',
            aiAudioRecap: 'Resumen de Audio IA',
            viewTranscript: 'Ver transcripción',
            transcript: 'Transcripción del resumen de audio IA',
            audioLoadError: 'No se puede cargar la grabación de audio',
            audioUnavailable: 'El audio no está disponible actualmente',
            transcriptUnavailable:
                'La transcripción no está disponible actualmente',
            fifteenSeconds: '15s',
            fastForward: 'Avanzar',
            rewind: 'Rebobinar',
        },
    },
    powerBI: {
        popupError:
            'Por favor, habilita las ventanas emergentes en tu navegador para ver el informe de Power BI.',
        title: 'Power BI',
    },
}
